import { Button, Typography } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { Maybe, UserDeliveryDetailFragment } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { LotteryUserForm, LotteryUserValue } from './LotteryUserForm'

export * from './fragments'

export type State = {
  user: Maybe<UserDeliveryDetailFragment>
  openSMSVerificationModal: boolean
  sendingVerificationLoading: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (values: LotteryUserValue) => Promise<void>
  onCloseSMSVerificationModal: () => void
  onSendVerificationSMS: () => void
}

export const LotteryUserInfoTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onSendVerificationSMS,
  onCloseSMSVerificationModal,
}) => {
  const { t } = useTranslation('lotteryUserInfo')
  const { routerNames } = useRouter()
  return (
    <BaseLayout
      margin
      header={{ back: true, title: t('title', 'お客様情報入力') }}
    >
      <Head title={routerNames.LotteryUserInfo} />
      <LotteryUserForm user={state.user} onSubmit={onSubmit} />
      <InformationModal
        open={state.openSMSVerificationModal}
        onClose={onCloseSMSVerificationModal}
        title={t('verifyTitle')}
        content={
          <Typography variant="body2">
            {t('verifyDesc', {
              phoneNumber: state.user?.formattedPhoneNumber,
            })}
          </Typography>
        }
        buttons={
          <Button
            sx={{ minWidth: 212, mt: 4 }}
            size="large"
            onClick={onSendVerificationSMS}
            loading={state.sendingVerificationLoading}
          >
            {t('verify')}
          </Button>
        }
        cancelText={t('close')}
      />
    </BaseLayout>
  )
}
